import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function SocialProofBar() {
  return <FadeIn data-id="element-283">
      <div className="w-full bg-gray-900 border-y border-gray-800 py-6 pt-[10px] pb-[10px]" data-id="element-284">
        <div className="max-w-5xl mx-auto px-4 flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-center font-medium" data-id="element-285">
          <div className="text-gray-300 text-[14px]" data-id="element-286">+500 estudiantes</div>
          <div className="hidden sm:block text-gray-600" data-id="element-287">•</div>
          <div className="text-gray-300 text-[14px]" data-id="element-288">6 Tomos</div>
          <div className="hidden sm:block text-gray-600" data-id="element-289">•</div>
          <div className="text-gray-300 text-[14px]" data-id="element-290">6 Bonos</div>
          <div className="hidden sm:block text-gray-600" data-id="element-291">•</div>
          <div className="flex gap-1 text-gray-300 text-[14px] items-center justify-start" data-id="element-292">
            4,9/5
            <div className="flex text-yellow-400 ml-1" data-id="element-293">
              <Star size={18} fill="currentColor" data-id="element-294" />
            </div>
          </div>
        </div>
      </div>
    </FadeIn>;
}